<nb-select
    #select
    fullWidth
    [placeholder]="placeholder"
    [disabled]="disabled"
    [multiple]="multiple"
    [selected]="value"
    (selectedChange)="onValueChange($event)"
    (click)="onTouched()"
    [ngxScrollLock]="select.isOpen"
>
    <nb-select-label
        [ngClass]="{
            'select__label-container': true,
            'select__label-container--modified': value?.length && !disabled && showClearButton
        }"
    >
        <p class="text-truncate select__label-text">
            <!-- Custom label for multi-select with "Select All" support -->
            <ng-container *ngIf="multiple && showSelectAll">
                {{ isAllSelected ? "All" : getMultiLabels(valuesAsArray) }}
            </ng-container>
            <!-- Custom label fallback when no "Select All" is shown -->
            <ng-container *ngIf="!showSelectAll && customLabel">
                {{ customLabel() }}
            </ng-container>
            <!-- Generic label fallback -->
            <ng-container *ngIf="!showSelectAll && !customLabel">
                {{ multiple ? getMultiLabels(valuesAsArray) : getSingleLabel() }}
            </ng-container>
        </p>
        <!-- Clear-All Button -->
        <button
            *ngIf="value?.length && !disabled && showClearButton"
            ghost
            nbButton
            (click)="clearAll()"
            class="select__clear-all"
            type="button"
        >
            <nb-icon icon="close"></nb-icon>
        </button>
    </nb-select-label>

    <!-- "Select All" option -->
    <nb-option *ngIf="multiple && showSelectAll" [value]="selectAllOption.value" (click)="toggleSelectAll()">
        {{ selectAllOption.label }}
    </nb-option>

    <!-- Normal options -->
    <nb-option *ngFor="let option of options" [value]="option.value" [disabled]="option.disabled">
        {{ option.label }}
    </nb-option>
</nb-select>
